'use client';

import React, { useState } from 'react';
import { createClient } from '@/lib/supabase/client';

export default function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');

    try {
      const supabase = createClient();
      const { error } = await supabase
        .from('newsletter_subscribers')
        .insert({ email: email.toLowerCase().trim() });

      if (error) {
        if (error.code === '23505') {
          setMessage("You're already subscribed! 👻");
          setStatus('success');
        } else {
          setMessage('Something went wrong. Please try again.');
          setStatus('error');
        }
      } else {
        setMessage("You're in! Expect chilling stories in your inbox. 🕯️");
        setStatus('success');
        setEmail('');
      }
    } catch {
      setMessage('Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  return (
    <div className="newsletter-signup">
      {status === 'success' ? (
        <div className="text-center py-4">
          <div className="text-2xl mb-2">👻</div>
          <p className="text-sm font-semibold" style={{ color: 'var(--primary)', fontFamily: 'var(--font-display)' }}>
            {message}
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
            className="w-full px-4 py-3 text-sm outline-none"
            style={{
              background: 'rgba(30,16,64,0.6)',
              border: '1px solid var(--border)',
              color: 'var(--foreground)',
              fontFamily: 'var(--font-mono)',
            }}
            aria-label="Email address for newsletter"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="btn-primary px-6 py-3 text-xs w-full"
          >
            {status === 'loading' ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="w-3 h-3 animate-spin" viewBox="0 0 24 24" fill="none">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                </svg>
                Subscribing...
              </span>
            ) : 'Subscribe'}
          </button>
        </form>
      )}
      {status === 'error' && (
        <p className="text-xs mt-2" style={{ color: '#ef4444' }}>{message}</p>
      )}
    </div>
  );
}
